import React, { createContext, useContext, useEffect, useState } from 'react';
import { changeLocale } from 'gatsby-plugin-intl';
import Cookies from 'js-cookie';

const LanguageContext = createContext(null);

const LANGUAGES = ['en', 'fr', 'de', 'da', 'nl'];
const CURRENCIES = ['EUR', 'DKK'];

export const LanguageContextProvider = ({ children }) => {
  const [language, setLanguage] = useState(Cookies.get('bluli-lang') || 'en');
  const [currency, setCurrency] = useState(Cookies.get('bluli-currency') || 'EUR');

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    changeLocale(newLanguage);
    Cookies.set('bluli-lang', newLanguage);
  };
  const changeCurrency = (newCurrency) => {
    setCurrency(newCurrency);
    Cookies.set('bluli-currency', newCurrency);
  };

  useEffect(() => {
    const cookieLang = Cookies.get('bluli-lang');
    const cookieCurrency = Cookies.get('bluli-currency');
    let lang = cookieLang;

    if (!cookieLang && typeof navigator !== 'undefined') {
      const langString = navigator.language.substring(0, 2);
      lang = langString;
    }

    if (CURRENCIES.includes(cookieCurrency)) {
      changeCurrency(cookieCurrency);
    } else {
      changeCurrency('EUR');
    }

    if (LANGUAGES.includes(lang)) {
      changeLanguage(lang);
    } else {
      changeLanguage('en');
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, currency, changeLanguage, changeCurrency }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const language = useContext(LanguageContext);
  return language;
};

export default LanguageContext;
